import type { CivilDate } from '@klopotun/domain';
import type { ChangeEvent } from 'react';
import { formatMonthName } from '../../../../features/payment-view/index.js';
import {
  type ChosenPeriod,
  formatMonthTitle,
  type ShownPeriod,
  toChosenPeriod,
} from '../../../../features/summary-view/index.js';
import { SelectField, type SelectOption } from '../../../../shared/ui/index.js';
import { usePeriodYears } from '../../lib/use-period-years.js';
import styles from './period-controls.module.css';

const WHOLE_YEAR = 'year';

const MONTHS_PER_YEAR = 12;

const MONTH_OPTIONS: SelectOption[] = [
  { value: WHOLE_YEAR, label: 'Увесь рік' },
  ...Array.from({ length: MONTHS_PER_YEAR }, (_slot, index) => ({
    value: String(index + 1),
    label: formatMonthTitle(formatMonthName(index + 1)),
  })),
];

type PeriodControlsProps = {
  shown: ShownPeriod;
  today: CivilDate;
  onChoose: (period: ChosenPeriod) => void;
};

const monthOfValue = (value: string): number | null =>
  value === WHOLE_YEAR ? null : Number(value);

export const PeriodControls = ({ shown, today, onChoose }: PeriodControlsProps) => {
  const years = usePeriodYears(today, shown.year);
  const yearOptions = years.map((year) => ({ value: String(year), label: String(year) }));

  const choose = (period: ShownPeriod): void => {
    onChoose(toChosenPeriod(period, today.year));
  };

  const changeYear = (event: ChangeEvent<HTMLSelectElement>): void => {
    choose({ year: Number(event.target.value), month: shown.month });
  };

  const changeMonth = (event: ChangeEvent<HTMLSelectElement>): void => {
    choose({ year: shown.year, month: monthOfValue(event.target.value) });
  };

  return (
    <div className={styles.controls}>
      <div className={styles.year}>
        <SelectField
          label="Рік"
          name="summary-year"
          options={yearOptions}
          value={String(shown.year)}
          hideLabel
          onChange={changeYear}
        />
      </div>
      <div className={styles.month}>
        <SelectField
          label="Місяць"
          name="summary-month"
          options={MONTH_OPTIONS}
          value={shown.month === null ? WHOLE_YEAR : String(shown.month)}
          hideLabel
          onChange={changeMonth}
        />
      </div>
    </div>
  );
};
